import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { apiURI, mainSite } from '../config.js';
import Bugsnag from '@bugsnag/expo';

/** STATE OBJECT */
const initialState = {
  loading_msg: 'idle',
  results_msg: '',
  streak_dates: [
    {
      day: '28',
      completed: false,
    },
    {
      day: '29',
      completed: false,
    },
    {
      day: '30',
      completed: false,
    },
    {
      day: '31',
      completed: false,
    },
    {
      day: '1',
      completed: false,
    },
    {
      day: '2',
      completed: false,
    },
    {
      day: '3',
      completed: false,
    },
    {
      day: '4',
      completed: false,
    },
    {
      day: '5',
      completed: false,
    },
    {
      day: '6',
      completed: false,
    },
    {
      day: '7',
      completed: false,
    },
    {
      day: '8',
      completed: false,
    },
    {
      day: '9',
      completed: false,
    },
    {
      day: '10',
      completed: false,
    },
    {
      day: '11',
      completed: false,
    },
    {
      day: '12',
      completed: false,
    },
    {
      day: '13',
      completed: false,
    },
    {
      day: '14',
      completed: false,
    },
    {
      day: '15',
      completed: false,
    },
    {
      day: '16',
      completed: false,
    },
    {
      day: '17',
      completed: false,
    },
    {
      day: '18',
      completed: false,
    },
    {
      day: '19',
      completed: false,
    },
    {
      day: '20',
      completed: false,
    },
    {
      day: '21',
      completed: false,
    },
    {
      day: '22',
      completed: false,
    },
    {
      day: '23',
      completed: false,
    },
    {
      day: '24',
      completed: false,
    },
    {
      day: '25',
      completed: false,
    },
    {
      day: '26',
      completed: false,
    },
    {
      day: '27',
      completed: false,
    },
    {
      day: '28',
      completed: false,
    },
    {
      day: '29',
      completed: false,
    },
    {
      day: '30',
      completed: false,
    },
    {
      day: '1',
      completed: false,
    },
  ],

  current_active_streak: 0,
};

export const fetchLatestStreakDates = createAsyncThunk(
  'streakDates/fetchLatestStreakDates',
  async (userId, { rejectWithValue }) => {
    Bugsnag.leaveBreadcrumb('Action fetchLatestStreakDates dispatched');
    const response = await fetch(`${apiURI}/get-client-workout-streak.php`, {
      method: 'POST',
      redirect: 'follow',
      headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
      body: JSON.stringify({ user_id: userId }),
    });

    const results = await response.json();

    ////console.log('GET STREAK DATES results: ', results);

    // did we get a successful response
    if (response.ok) {
      // verfiy a successful authorization
      if (!results.success) {
        return rejectWithValue(results.msg);
      }

      return results;
    } else {
      // return the status text from the response
      Bugsnag.notify(
        'Api Error, get-client-workout-streak: ' + response.text()
      );
      return rejectWithValue(response.text());
    }
  }
);

/** DEFINE REDUCERS */
export const cbcStreakSlice = createSlice({
  name: 'streakDates',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchLatestStreakDates.pending, (state) => {
        state.loading_msg = 'pending';
        state.results_msg = 'Fetching your latest Streak Dates';
      })
      .addCase(fetchLatestStreakDates.fulfilled, (state, { payload }) => {
        state.loading_msg = 'idle';
        state.results_msg = '';
        //////console.log('fetchLatestStreakDates reducer payload', payload);
        state.streak_dates = payload.streak_calendar; //UNCOMMENT THIS WHEN FINISHED TESTING
        state.current_active_streak = payload.current_active_streak;
        //state.streak_dates = initialState.streak_dates;
      })
      .addCase(fetchLatestStreakDates.rejected, (state, { payload }) => {
        state.loading_msg = 'failed';
        state.results_msg = payload;
      });
  },
});

// extract the reducer from the slice
const { reducer } = cbcStreakSlice;

// export the reducer
export default reducer;
